import { forwardRef } from 'react';
import { MLPVersion } from '../types/enums';
import { TableVersion, SortOrders, AdminPaginationStyle, TableRowType } from './types/enums';
import type { TableProps, TableTheme, PageSize } from './types/propType';
import DefaultTable from './DefaultTable/DefaultTable';
import AdminTable from './AdminTable/AdminTable';
import Pagination from './Pagination/Pagination';
import { TableBody, TableHeader } from './TableComponents';

const DEFAULT_PAGE_SIZE_DATA: PageSize[] = [
  { id: 1, rows: 5 },
  { id: 2, rows: 10 },
  { id: 3, rows: 25 },
];

const Table = forwardRef<HTMLTableElement, TableProps>((props: TableProps, ref) => {
  const {
    tableVersion = TableVersion.ADMIN,
    mlpVersion = MLPVersion.ONE,
    enableCheckbox,
    enableRadioButton,
    ...restProps
  } = props;

  // Priority logic: if both are enabled, prioritize checkbox and ignore radiobutton
  const adjustedProps: TableProps = {
    ...restProps,
    ...(enableCheckbox !== undefined && { enableCheckbox }),
    ...(enableRadioButton !== undefined && {
      enableRadioButton: enableCheckbox && enableRadioButton ? false : enableRadioButton,
    }),
  };

  return tableVersion === TableVersion.ADMIN || mlpVersion === MLPVersion.ONE ? (
    <AdminTable {...adjustedProps} forwardedRef={ref} mlpVersion={mlpVersion} tableVersion={tableVersion} />
  ) : (
    <DefaultTable {...adjustedProps} forwardedRef={ref} mlpVersion={mlpVersion} tableVersion={tableVersion} />
  );
});
Table.displayName = 'Table';
export default Table;
export { TableHeader, TableBody, Pagination };
export { SortOrders, AdminPaginationStyle, DEFAULT_PAGE_SIZE_DATA, TableVersion, TableRowType };
export type { TableProps, TableTheme, PageSize };
